import React, {useContext} from "react";
import AuthenticationService from "../services/AuthenticationService";
import PermanentSurvey from "./PermanentSurvey";
import CountryContext from "../CountryContext";

const TintometerSurvey = () => {

  const userData = AuthenticationService.getUserData();

  // context
  const {country} = useContext(CountryContext);

  return (
    <PermanentSurvey
      returnPath={`/${country.code}/tintometers`}
      worksite={null}
      userData={userData}
      updateServicesSurveys={() => {}}
    />
  )
}

export default TintometerSurvey;